module.exports = __webpack_public_path__ + "static/pie-013ef6e3f0dafd03a83b365f939a54f9.png";